import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/lib/data";
import { Reveal, Label } from "@/components/Reveal";

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials"
      className="relative py-24 md:py-32 bg-[#111827] border-y border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <Label>06 — Dicono di noi</Label>
        </Reveal>
        <div className="mt-12 grid md:grid-cols-2 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.blockquote
              key={i}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.12 }}
              className="relative bg-[#0A0E14] border border-white/10 p-10 hover:border-[#F5871F]/40 transition-colors"
            >
              <Quote size={40} className="text-[#F5871F]/40 mb-6" />
              <p className="font-display text-2xl md:text-3xl leading-snug tracking-tight text-white">
                “{t.q}”
              </p>
              <footer className="mt-8 flex items-center gap-3">
                <span className="h-px w-8 bg-[#00C8D7]" />
                <span className="font-mono-tech text-xs uppercase tracking-[0.2em] text-slate-400">
                  {t.a}
                </span>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
